import {
  DC as _DC,
  ticketTypes as _ticketTypes,
} from '../../../features/support/controllers/variables';

export const DC = _DC;
export const ticketTypes = _ticketTypes;
